/**
 * The capabilities that open the office's work order and crew pages (any of them). Kept apart from
 * shared.tsx so the router and navigation import them without the pages' components. The server
 * enforces the same lists (domain/api/work_orders.py READS, domain/api/crews.py READS).
 */
export const WORK_ORDER_READ = ["work_orders.view_all", "work_orders.manage", "work_orders.assign", "work_orders.approve"];
/** Crews and the work settings are readable by these; changes need crews.manage. */
export const CREW_READ = ["crews.manage", "work_orders.view_all", "work_orders.manage", "work_orders.assign", "schedule.view"];
